import { css } from 'src/styles/theme';

export const StylesOV = css``;
